import util from '../util'

let controller = 'Correntistas'
export default Object.assign({}, util.GetCrud(controller, null), {
  CriaCorrentistaDaPessoa: function (documentoFederal, codigoParceiro) {
    let dto = {
      DocumentoFederal: documentoFederal,
      CodigoParceiro: codigoParceiro
    }
    return util.Axios.Post(controller + '/CriaCorrentistaDaPessoa', dto)
  },
  GetByDocumento: function (documentoFederal, codigoParceiro) {
    let dto = {
      parameters: [
        { name: 'documentoFederal', value: documentoFederal },
        { name: 'codigoParceiro', value: codigoParceiro }
      ]
    }
    return util.Axios.GetAll(controller + '/GetByDocumento', dto)
  },
  GetComRelacionamentos: function (id) {
    return util.Axios.Get(controller + '/GetComRelacionamentos', id)
  },
  GetByCodigoConta: function (id) {
    return util.Axios.Get(controller + '/GetByCodigoConta', id)
  },
  GetAll: function (dto, options) {
    if (options && options.data) dto.data = options.data
    return util.Axios.GetAll(controller, dto)
  },
  ObterTitularConta: function (codigoConta) {
    return util.Axios.Get(controller + `/TitularConta/${codigoConta}`)
  }
})
